import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom/dist";
import PropTypes from "prop-types";
import { Table, Spin } from "antd";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import SalaryTypeBadge from "./Salarybadge";

const ViewCTC = ({ viewObj }) => {
  const navigate = useNavigate();
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [salaryList, setSalaryList] = useState([]);
  const [orgSalaryId, setOrgSalaryId] = useState(null);
  const [RegId, setRegId] = useState(null);
  const [hystryList, setHystryList] = useState([]);
  console.log(superIdData);
  console.log(hystryList);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    if (viewObj) {
      setOrgSalaryId(viewObj.OrgSalId);
      setRegId(viewObj.RegId);
    }
  }, [viewObj]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (!tokenData || !orgSalaryId) return;

    const fetchSalaryList = async () => {
      const params = new URLSearchParams({
        OrgSalaryId: orgSalaryId,
      });
      setDataLoading(true);
      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/EmployeCTC/GetctcdetailsForEmp?${params.toString()}`,
          {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${tokenData}`,
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch salary list");
        }

        const data = await response.json();

        if (data?.status) {
          setSalaryList(data.ResultData || []);
        } else {
          console.error("Invalid API response:", data);
          setSalaryList([]);
        }
      } catch (error) {
        console.error("Error fetching salary list:", error);
        setSalaryList([]);
      }
      finally {
        setDataLoading(false);
      }
    };

    fetchSalaryList();
  }, [tokenData, orgSalaryId]);

  useEffect(() => {
    if (!tokenData || !RegId) return;

    const fetchHistoryList = async () => {
      const params = new URLSearchParams({
        RegId: RegId,
      });
      setDataLoading(true);
      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/EmployeCTC/GetEmpCtcHistory?${params.toString()}`,
          {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${tokenData}`,
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch setHystry List");
        }

        const data = await response.json();

        if (data?.status) {
          setHystryList(data.ResultData || []);
        } else {
          console.error("Invalid API response:", data);
          setHystryList([]);
        }
      } catch (error) {
        console.error("Error fetching setHystry List:", error);
        setHystryList([]);
      }
      finally {
        setDataLoading(false);
      }
    };

    fetchHistoryList();
  }, [tokenData, RegId]);


  if (!viewObj) {
    return null;
  }
  console.log("ViewCTC rendered with viewObj:", viewObj?.RegId);
  // console.log(superIdData, salaryList);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const salaryTypeMap = {
    Basic: "Earning",
    HRA: "Earning",
    Conveyance: "Earning",
    Medical: "Earning",
    Special: "Earning",
    Incentive: "Earning",
    OT: "Earning",
    Bonus: "Earning",

    PF: "Deduction",
    ESI: "Deduction",
    Tax: "Deduction",
    PT: "Deduction",
    Advance: "Deduction",
    "Loss Of Pay": "Deduction",
  };
  const earningList = salaryList.filter(
    (item) => salaryTypeMap[item.SalaryHeadsName] === "Earning"
  );

  const deductionList = salaryList.filter(
    (item) => salaryTypeMap[item.SalaryHeadsName] === "Deduction"
  );

  const columns = [
    {
      title: "Salary Head",
      dataIndex: "SalaryHeadsName",
      key: "SalaryHeadsName",
      ellipsis: true,
    },
    // {
    //   title: "Type",
    //   align: "center",
    //   width: 80,
    //   render: (_, record) => {
    //     const type = salaryTypeMap[record.SalaryHeadsName] || "Earning";
    //     return <SalaryTypeBadge type={type} />;
    //   },
    // },
    {
      title: "Amount (₹)",
      dataIndex: "Amount",
      key: "Amount",
      render: (value) => (value ? value : "0"),
    },
  ];

  // const ctcHistory = [
  //   {
  //     key: 1,
  //     updatedOn: "2024-03-15",
  //     monthlyCTC: 42000,
  //     yearlyCTC: 504000,
  //     revisedBy: "HR Admin",
  //   },
  //   {
  //     key: 2,
  //     updatedOn: "2023-03-20",
  //     monthlyCTC: 38000,
  //     yearlyCTC: 456000,
  //     revisedBy: "Payroll Manager",
  //   },
  //   {
  //     key: 3,
  //     updatedOn: "2022-04-01",
  //     monthlyCTC: 32000,
  //     yearlyCTC: 384000,
  //     revisedBy: "System",
  //   },
  // ];

  const historyColumns = [
    {
      title: "Revised On",
      dataIndex: "EffectiveDate",
      // align: "center",
      render: (val) => formatDate(val),
    },
    {
      title: "Monthly (₹)",
      dataIndex: "MonthlyCTC",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    {
      title: "Yearly (₹)",
      dataIndex: "AnnualCTC",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    // {
    //   title: "Revised by",
    //   dataIndex: "revisedBy",
    //   render: () => "HR Admin",
    // },
  ];

  return (
    <div>
      {/* .ctc-table1 {
      width: 100% !important;
      padding: 0 60px !important;
    } */}
      <style>
        {`
   

    .ctc-table1 .ant-table-thead > tr > th {
      background-color: #d2e6f5ff !important; 
    }

    .ctc-table1 table {
      table-layout: auto;
    }

    .ctc-info-2col {
      display: grid;
      column-gap: 10px;
      row-gap: 8px;
    }

    .ctc-pair {
      display: flex;
      align-items: flex-start;
    }

    .ctc-label {
      font-weight: 600;
    }

    .ctc-value {
      font-weight: 500;
    }
  `}
      </style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewCTC"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "45%", maxWidth: "45%" }}
      >
        <div className="offcanvas-header my-0 py-3">
    <h4 id="offcanvasRightLabel" className="mb-0">
          {viewObj?.UserName}&apos;s Salary Details
</h4>

          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>

        <hr className="my-1" />

        <div className="offcanvas-body px-3">
          <div className="mb-3 fs-16 row">
            {/* <div className="col-8 row mb-2">
              <span className="col-3">Employee</span>
              <span className="col-9">: {viewObj.UserName}</span>
            </div> */}
                <div className="col-6 row mb-2">
              <span className="col-3">Badge</span>
              <span className="col-9">: {viewObj?.Badge}</span>
            </div>

            {/* <div className="col-4">
              <span className=""> Badge</span>
              <span className="">: {viewObj?.Badge}</span>
            </div> */}
            <div className="col-6 row">
              <span className="col-3">Branch</span>
              <span className="col-9">: {viewObj?.Branch}</span>
            </div>

          </div>

          {dataLoading ? (
            <div className="text-center my-4">
              <Spin size="large" />
              <p>Loading data...</p>
            </div>
          ) : (
            // <Table
            //   columns={columns}
            //   className="ctc-table1 px-5 "
            //   dataSource={salaryList}
            //   pagination={false}
            //   bordered
            //   size="small"
            //   tableLayout="fixed"
            // />
            <div style={{ display: "flex", gap: "15px", marginTop: "10px" }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <SalaryTypeBadge type="Earning" />
                  Earnings
                </h5>
                <Table
                  columns={columns}
                  dataSource={earningList}
                  className="ctc-table1"
                  pagination={false}
                  size="small"
                  bordered
                />
              </div>

              <div style={{ flex: 1 }}>
                <h5 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <SalaryTypeBadge type="Deduction" />
                  Deductions
                </h5>
                <Table
                  columns={columns}
                  dataSource={deductionList}
                  className="ctc-table1"
                  pagination={false}
                  size="small"
                  bordered
                />
              </div>
            </div>

          )}
          <div className="mb-3 mt-3 fs-16 row">
        
            <div className="col-4">
              <span className="">Monthly</span>
              <span className="" style={{ color: "blue" }}>: ₹{viewObj.MonthlyCTC?.toLocaleString("en-IN")}</span>
            </div>

            <div className="col-4">
              <span className=""> Annual</span>
              <span className="" style={{ color: "green" }}>: ₹{viewObj.AnnualCTC?.toLocaleString("en-IN")}</span>
            </div>
            <div className="col-4">
              <span className="">From</span>
              <span className="" style={{ color: "blue" }}>: {formatDate(viewObj.EffectiveDate)}</span>
            </div>

          </div>
          {/* <div className="mt-3 fs-16 ctc-info-2col">
            <div className="ctc-pair">
              <span className="ctc-label">Monthly CTC</span>
              <span className="ctc-value" style={{ color: "blue" }}>: ₹{viewObj.MonthlyCTC?.toLocaleString()}</span>
            </div>
            <div className="ctc-pair">
              <span className="ctc-label">Annual CTC</span>
              <span className="ctc-value" style={{ color: "green" }}>: ₹{viewObj.AnnualCTC?.toLocaleString()}</span>
            </div>
            <div className="ctc-pair">
              <span className="ctc-label">Effective From</span>
              <span className="ctc-value" style={{ color: "blue" }}>: {formatDate(viewObj.EffectiveDate)}</span>
            </div>
          </div> */}
          <hr className="my-2" />

          <h5 className="mb-2">Increment History</h5>
          {dataLoading ? (
            <div className="text-center my-4">
              <Spin size="large" />
              <p>Loading data...</p>
            </div>
          ) : (
            <Table
              columns={historyColumns}
              className="ctc-table px-5"
              dataSource={hystryList}
              pagination={false}
              size="small"
              bordered
            />
          )}
        </div>
      </div>
    </div>
  );
};

ViewCTC.propTypes = {
  viewObj: PropTypes.shape({
    AnnualCTC: PropTypes.number,
    Badge: PropTypes.string,
    Branch: PropTypes.string,
    BranchId: PropTypes.number,
    DeptId: PropTypes.number,
    EMPActive: PropTypes.bool,
    EffectiveDate: PropTypes.string,
    EndDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.oneOf([null])
    ]),
    IsActive: PropTypes.bool,
    IsESIEnabled: PropTypes.oneOf([0, 1]),
    IsPFEnabled: PropTypes.oneOf([0, 1]),
    MonthlyCTC: PropTypes.number,
    OrgSalId: PropTypes.number,
    RegId: PropTypes.number,
    SuperId: PropTypes.number,
    UserName: PropTypes.string.isRequired,
  }).isRequired,
};

export default ViewCTC;
